import { render, staticRenderFns } from "./changeOwnership.vue?vue&type=template&id=33074378&"
import script from "./changeOwnership.vue?vue&type=script&lang=js&"
export * from "./changeOwnership.vue?vue&type=script&lang=js&"
import style0 from "./changeOwnership.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports